module.exports = __webpack_public_path__ + "img/thumbnail_CuviersDwarfCaiman_f_normal.66c6a547.png";